module.exports = __webpack_public_path__ + "static/media/warehouse.e9f78fbd.svg";